/*******************************************************
 * SECURITY SERVICE
 *******************************************************/
import Auth from "@app/auth";
"use strict";


/**
 * Module SERVICES
 */
angular.module("services")


	/**
	 * SecurityService
	 *
	 * Handles :
	 * - token retrieval and storage / deletion
	 * - permissions retrieval and storage
	 * - permissions checking
	 */
	.factory("SecurityService", function () {

		return {


			/**
			 * Verifies that user is allowed to access to a given module.
			 * Can be used to check access against routes (check "routeCHanged" listener in app.js)
			 * or for some buttons or specific parts in a page (check permission-needed directive).
			 * @param moduleName
			 * @returns boolean
			 */
			checkAccess: function (moduleName) {
				var roles = JSON.parse(window.localStorage.getItem("roles"));
				if (roles) {
					return roles.some(role => role === moduleName);
				}
				return false;
			},

			logout() {
				Auth.logout();
			},

			hasRight(rightName){
				return this.checkAccess(rightName) ;
			},

		};
	}
	)
;
